export default "__VITE_ASSET__cSgNttis__"